import commondescrEdit from './edit.vue'
import commondescrList from './list.vue'
import commondescrDetails from './details.vue'
import publicList from './publicList.vue'
import processList from './processList.vue'
import fileDownload from './fileDownload.vue'
import * as commondescrMain from './commondescrMain'

let a = Object.assign({ commondescrEdit, commondescrList, commondescrDetails, publicList, fileDownload, processList }, commondescrMain)
export default a
